// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xo0u","question":"styles_question__1nNag","description":"styles_description__3tbyt"};